// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    login as loginApi,
    logout as logoutApi,
    signup as signupApi,
    forgotPassword as forgotPasswordApi,
    mobileVerification as mobileVerificationApi,
    userVerification as userVerificationApi,
    forgotPasswordConfirm,
} from '../../helpers/';

import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { authApiResponseSuccess, authApiResponseError } from './actions';
import { AuthActionTypes } from './constants';

const api = new APICore();

/**
 * Login the user
 * @param {*} payload - username and password
 */

function* login({ payload: { contact } }) {
    try {
        const response = yield call(loginApi, { contact });
        const user = response.data.response;

        if (user === 'loggedIn') {
            // NOTE - You can change this according to response format from your api
            yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, 'loggedIn'));
            api.setLoggedInUser(null);
            setAuthorization(null);
        } else if (user !== null) {
            api.setLoggedInUser(user);
            setAuthorization(user['token']);
            yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
        } else {
            yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, false));
            api.setLoggedInUser(null);
            setAuthorization(null);
        }
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

// function* login({ payload: { email, password } }) {
//     try {
//         const response = yield call(loginApi, { email, password });
//         const user = response.data.response;

//         if (user === 'loggedIn') {
//             // NOTE - You can change this according to response format from your api
//             yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, 'loggedIn'));
//             api.setLoggedInUser(null);
//             setAuthorization(null);
//         } else if (user !== null) {
//             api.setLoggedInUser(user);
//             setAuthorization(user['token']);
//             yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
//         } else {
//             yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, true));
//             api.setLoggedInUser(null);
//             setAuthorization(null);
//         }
//     } catch (error) {
//         yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
//         api.setLoggedInUser(null);
//         setAuthorization(null);
//     }
// }

/**
 * Logout the user
 */
function* logout({ payload: { email } }) {
    try {
        yield call(logoutApi, { email });
        api.setLoggedInUser(null);
        setAuthorization(null);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGOUT_USER, {}));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.LOGOUT_USER, error));
    }
}

function* signup({ payload: { fullname, email, password } }) {
    try {
        const response = yield call(signupApi, { fullname, email, password });
        const user = response.data;
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(authApiResponseSuccess(AuthActionTypes.SIGNUP_USER, user));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.SIGNUP_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

function* forgotPassword({ payload: { username, contact } }) {
    try {
        const response = yield call(forgotPasswordApi, { username, contact });

        if (response.data.isSucess === false) {
            yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD, response.data.error));
        } else if (response.data.isSucess === true) {
            yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD, response.data.response));
        }
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD, error));
    }
}

function* forgotPasswordChange({ payload: { data } }) {
    try {
        const response = yield call(forgotPasswordConfirm, data);
        yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD_CHANGE, response.data));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD_CHANGE, error));
    }
}

function* mobileVerification({ payload: { contact } }) {
    try {
        const response = yield call(mobileVerificationApi, { contact });

        if (response.data.isSucess === false) {
            yield put(authApiResponseError(AuthActionTypes.MOBILE_VERIFICATION, response.data.error));
        } else if (response.data.isSucess === true) {
            yield put(authApiResponseSuccess(AuthActionTypes.MOBILE_VERIFICATION, response.data.response));
        }
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.MOBILE_VERIFICATION, error));
    }
}

function* userVerification({ payload: { userId, password } }) {
    try {
        const response = yield call(userVerificationApi, { userId, password });

        if (response.data.isSucess === false) {
            yield put(authApiResponseError(AuthActionTypes.USER_VERIFICATION, response.data.error));
        } else if (response.data.isSucess === true) {
            yield put(authApiResponseSuccess(AuthActionTypes.USER_VERIFICATION, response.data.response));
        }
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.USER_VERIFICATION, error));
    }
}

export function* watchLoginUser() {
    yield takeEvery(AuthActionTypes.LOGIN_USER, login);
}

export function* watchLogout() {
    yield takeEvery(AuthActionTypes.LOGOUT_USER, logout);
}

export function* watchSignup() {
    yield takeEvery(AuthActionTypes.SIGNUP_USER, signup);
}

export function* watchForgotPassword() {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD, forgotPassword);
}

export function* watchForgotPasswordChange() {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD_CHANGE, forgotPasswordChange);
}

export function* watchMobileVerification() {
    yield takeEvery(AuthActionTypes.MOBILE_VERIFICATION, mobileVerification);
}

export function* watchUserVerification() {
    yield takeEvery(AuthActionTypes.USER_VERIFICATION, userVerification);
}

function* authSaga() {
    yield all([
        fork(watchLoginUser),
        fork(watchLogout),
        fork(watchSignup),
        fork(watchForgotPassword),
        fork(watchForgotPasswordChange),
        fork(watchMobileVerification),
        fork(watchUserVerification),
    ]);
}

export default authSaga;
